import { Box } from '@chakra-ui/react';
import { ConnectWalletButton, LogoStatus, SimpleDisplayModalContent, SimpleModalHead, SimpleModalView } from '@cosmology-ui/react';
import React, { useCallback } from 'react';
export const RejectedView = ({
  onClose,
  onReturn,
  wallet
}) => {
  const {
    walletInfo: {
      prettyName,
      logo
    }
  } = wallet;
  const onReconnect = useCallback(() => {
    wallet.connect(false);
  }, [wallet]);
  const modalHead = /*#__PURE__*/React.createElement(SimpleModalHead, {
    title: prettyName,
    backButton: true,
    onClose: onClose,
    onBack: onReturn
  });
  const modalContent = /*#__PURE__*/React.createElement(SimpleDisplayModalContent, {
    status: LogoStatus.Error,
    logo: logo,
    contentHeader: 'Request Rejected',
    contentDesc: wallet.rejectMessageTarget || 'Connection permission is denied.',
    bottomButton: /*#__PURE__*/React.createElement(Box, {
      px: 6
    }, /*#__PURE__*/React.createElement(ConnectWalletButton, {
      buttonText: 'Reconnect',
      onClick: onReconnect
    }))
  });
  return /*#__PURE__*/React.createElement(SimpleModalView, {
    modalHead: modalHead,
    modalContent: modalContent
  });
};